var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({staticClass:"btn",class:{
    'btn--border': !_vm.isUndefiend(_vm.border),
    'btn--primary': _vm.type === 'primary',
    'btn--text': !_vm.isUndefiend(_vm.text)
  },attrs:{"href":_vm.href,"target":"_blank"},on:{"click":_vm.handleClick}},'a',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('common').buyNow))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }